module.exports = __webpack_public_path__ + "static/media/pay-icon.4fb90151.svg";